import * as React from "react";
import { type ReactNode } from "react";

type RenderFunction = (onFocus: () => void, onBlur: () => void, retracted: boolean) => React.ReactNode;

// eslint-disable-next-line @typescript-eslint/no-use-before-define
type Props = typeof RetractableInput.defaultProps & {
    hasValue: boolean;
    label: ReactNode;
    children: RenderFunction | React.ReactNode;
};

interface State {
    focus: boolean;
}

export default class RetractableInput extends React.Component<Props, State> {
    public static defaultProps: {
        top: string | number;
        left: string | number;
        retractedTop: string | number;
        retractedLeft: string | number;
        wrapperClasses: string;
        labelClasses: string;
        style: React.CSSProperties;
    } = {
        top           : "2rem",
        left          : "1rem",
        retractedTop  : 0,
        retractedLeft : 0,
        wrapperClasses: "",
        labelClasses  : "",
        style         : {},
    };

    constructor(props: Props) {
        super(props);

        this.state = {
            focus: false,
        };

        this.handleFocus = this.handleFocus.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }

    protected handleFocus(): void {
        this.setState({
            focus: true,
        });
    }

    protected handleBlur(): void {
        this.setState({
            focus: false,
        });
    }

    public render(): React.ReactNode {
        const classes = [ "retractable-input-label truncate max-w-full", this.props.labelClasses ];
        const retracted = this.props.hasValue || this.state.focus;

        if(retracted) {
            classes.push("retracted");
        }

        const style = {
            top : (retracted ? this.props.retractedTop : this.props.top),
            left: (retracted ? this.props.retractedLeft : this.props.left),
        };

        const wrapperClasses = this.props.wrapperClasses + " retractable-input";

        return (
            <div
                className={wrapperClasses}
                style={this.props.style}
            >
                <span
                    className={classes.join(" ")}
                    style={style}
                >
                    {this.props.label}
                </span>
                {
                    typeof this.props.children === "function" ?
                        (this.props.children as RenderFunction)(this.handleFocus, this.handleBlur, retracted) :
                        this.props.children
                }
            </div>
        );
    }
}
